import { Controller } from '@hotwired/stimulus'

const DEBOUNCE_MS = 300

export default class extends Controller {
  static values = { pricingUrl: String }
  static targets = ['pitchRadio']

  #debounceTimer = null

  connect() {
    this.#update()
  }

  update() {
    clearTimeout(this.#debounceTimer)
    this.#debounceTimer = setTimeout(() => this.#update(), DEBOUNCE_MS)
  }

  #update() {
    this.#updateParticipantsMax()
    this.#filterPitchesByCapacity()
    this.#refreshPricingFrame()
  }

  #refreshPricingFrame() {
    const frame = document.getElementById('reservation_pricing')
    if (!frame) return

    const params = new URLSearchParams(new FormData(this.element))
    frame.src = `${this.pricingUrlValue}?${params}`
  }

  #updateParticipantsMax() {
    const pitch = this.#selectedPitch()
    const input = this.element.querySelector('[name*="participants_count"]')
    if (!pitch || !input) return

    input.max = pitch.dataset.reservationPricingCapacity || ''
  }

  #filterPitchesByCapacity() {
    const input = this.element.querySelector('[name*="participants_count"]')
    const count = parseInt(input?.value, 10)

    this.pitchRadioTargets.forEach((radio) => {
      const label = radio.closest('label')
      if (!label) return

      const dateAvailable = radio.dataset.reservationPricingDateAvailable === 'true'
      if (!dateAvailable) return

      const capacity = parseInt(radio.dataset.reservationPricingCapacity, 10)
      const available = !count || !capacity || capacity >= count

      radio.disabled = !available
      label.classList.toggle('opacity-60', !available)
      label.classList.toggle('cursor-not-allowed', !available)
      label.classList.toggle('cursor-pointer', available)
    })
  }

  #selectedPitch() {
    return [...this.element.querySelectorAll("input[type='radio']")].find(
      (r) => r.name.includes('pitch_id') && r.checked,
    )
  }
}
